// import { legacy_createStore as createStore } from 'redux';
// import loginReducer from '../reducers/loginReducer';

// const store = createStore(loginReducer);

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import productReducer from "./productSlice";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

// Define the persist config
const persistConfig = {
  key: 'root',      // Key for the storage
  storage,          // Type of storage (localStorage here)
};

// Wrap the product reducer with persistReducer
const persistedProductReducer = persistReducer(persistConfig, productReducer);

// Create the store and pass the persisted reducer
export const store = configureStore({
  reducer: {
    products: persistedProductReducer,
  },
});

// Create a persistor
export const persistor = persistStore(store);
